(() => {
  if (!('ResizeObserver' in window) || !('DOMMatrix' in window)) return;
  const watched = new Set();
  let scheduled = false;
  const eligible = media => media.closest('#art-container.surface-1 .main-art') ||
    media.closest('main[data-template="collection.canvas"] .card-gallery__hover-primary');
  const origin = value => value.split(' ').map(Number.parseFloat);

  function fitSide(media) {
    if (!media.clientWidth || !eligible(media)) return;
    const front = getComputedStyle(media);
    const side = getComputedStyle(media, '::after');
    if (side.content === 'none' || side.transform === 'none') return;
    const width = Number.parseFloat(front.width), height = Number.parseFloat(front.height);
    const sideWidth = Number.parseFloat(side.width), sideHeight = Number.parseFloat(side.height);
    const left = Number.parseFloat(side.left) + Number.parseFloat(front.borderLeftWidth);
    const top = Number.parseFloat(side.top) + Number.parseFloat(front.borderTopWidth);
    if (![width, height, sideWidth, sideHeight, left, top].every(Number.isFinite) || !sideHeight) return;
    const frontMatrix = new DOMMatrix(front.transform);
    const sideMatrix = new DOMMatrix(side.transform);
    const [ox, oy] = origin(front.transformOrigin);
    const [sx, sy] = origin(side.transformOrigin);
    const project = (matrix, x, y, z = 0) => {
      const p = matrix.transformPoint(new DOMPoint(x, y, z));
      return { x: p.x / p.w, y: p.y / p.w, z: p.z / p.w };
    };
    const frontY = (x, y, z = 0) => project(frontMatrix, x - ox, y - oy, z).y + oy;
    const limits = [frontY(0, 0), frontY(width, 0), frontY(0, height), frontY(width, height)];
    const minY = Math.min(...limits), maxY = Math.max(...limits);
    const sideY = (x, y) => {
      const p = project(sideMatrix, x - sx, y - sy);
      return frontY(left + sx + p.x, top + sy + p.y, front.transformStyle === 'preserve-3d' ? p.z : 0);
    };
    // Invert the existing CSS projection at both edges, without moving or rescaling the preview.
    const cuts = [0, sideWidth].map(x => {
      const start = sideY(x, 0), end = sideY(x, sideHeight);
      const clamp = value => Math.max(0, Math.min(100, value));
      return [clamp(100 * (minY - start) / (end - start)), clamp(100 * (maxY - start) / (end - start))];
    });
    media.style.setProperty('--artesta-side-clip', `polygon(0 ${cuts[0][0]}%,100% ${cuts[1][0]}%,100% ${cuts[1][1]}%,0 ${cuts[0][1]}%)`);
    media.classList.add('artesta-canvas-edge-fit');
  }

  const resize = new ResizeObserver(() => schedule());
  function scan() {
    scheduled = false;
    for (const media of watched) {
      if (media.isConnected && eligible(media)) continue;
      media.style.removeProperty('--artesta-side-clip');
      media.classList.remove('artesta-canvas-edge-fit');
      resize.unobserve(media);
      watched.delete(media);
    }
    for (const media of document.querySelectorAll('#art-container.surface-1 .main-art .product-media, main[data-template="collection.canvas"] .card-gallery__hover-primary .product-media')) {
      if (!watched.has(media)) { watched.add(media); resize.observe(media); }
      fitSide(media);
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' || record.target.id === 'art-container')) schedule();
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-frame'] });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('transitionend', event => {
    if (watched.has(event.target)) schedule();
  });
  scan();
})();
